export const scrollToError = () => {
  const errorSpan = document.querySelector('[class*="error"]');

  if (errorSpan && errorSpan.textContent && errorSpan.scrollIntoView) {
    errorSpan.scrollIntoView({ block: "center" });
  }
};
